"use strict";

const LoginCtrl = function(AuthService, Notification) {
    var ctrl = this;

    ctrl.$onInit = function(){
      ctrl.model = {
        username: '',
        password: '',
        remember: false
      };
    };

    ctrl.login = function(form){
      if (form.$valid){
        AuthService.login(ctrl.model.username, ctrl.model.password, ctrl.model.remember).then(
          function(){
            //Notification.success('Sie wurden erfolgreich am System angemeldet.');
          },
          function(response){
            if (response.status === 401) {
              Notification.error('Die Anmeldung konnte nicht durchgeführt werden. Die angegebenen Daten waren nicht korrekt.');
            } else {
              Notification.error('Die Anmeldung konnte nicht durchgeführt werden: <br/>&quot;<samp>' + response.data.details + '</samp>&quot;');
            }
            ctrl.model.password = "";
          }
        );
      }
    };
  }
LoginCtrl.$inject = ['AuthService', 'Notification']

module.exports = {
  template: require('./login.html'),
  controller: LoginCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/login/login.component.js